import fbUtils from "../firebase/firebaseUtils";
import { loadUserModelForFirebaseUser } from "../firebase/firebaseModels";
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { FIREBASE_FUNCTION_CREATE_CUSTOM_TOKEN } from "../firebase/constants";
import { AuthProviderInterface } from '../auth';
import logging from "../../utils/logging";

const log = logging.getLogger("firebase-auth");

export async function signInWithClerkToken(token) {
  log.debug("Signing in with Clerk token: ", token);
  
  const createCustomTokenFunc = fbUtils.getCallableFunction(FIREBASE_FUNCTION_CREATE_CUSTOM_TOKEN);

  log.debug("createCustomTokenFunc: ", createCustomTokenFunc);

  try {
    const result = await createCustomTokenFunc({ clerkToken: token });

    log.info("Got custom Firebase token result: ", result);

    const customToken = result.data;

    log.info("Got custom Firebase token: ", customToken);

    const userCredentials = await signInWithCustomToken(fbUtils.auth(), customToken);

    log.info("Signed in with Clerk token & firebase token: ", token, customToken, userCredentials);

    return userCredentials;
  } catch (error) {
    log.error("Error signing in with Clerk token: ", error);
    throw error;
  }
}

export class FirebaseAuthProvider extends AuthProviderInterface {
  constructor() {
    super();
    this.auth = getAuth();
  }

  async getCurrentUser() {
    return this.auth.currentUser;
  }

  async getAnonymousUser() {
    const auth = fbUtils.auth();
    try {
      await auth.signInAnonymously();
      // log.debug("Got anonymous user creds: ", creds, auth.currentUser);
      return auth.currentUser;
    } catch (e) {
      log.error("Error getting anonymous user: ", e);
    }
  }

  async watchAuthedUser(callback) {
    const auth = fbUtils.auth();
    try {
      await auth.onAuthStateChanged((firebaseUser) => {
        const user = loadUserModelForFirebaseUser(firebaseUser);
        callback(user);
      });
    } catch (e) {
      log.error("Error watching auth state: ", e);
    }
  }

  async logOut() {
    try {
      
      const auth = fbUtils.auth();
      return auth.signOut();

    } catch (error) {
      console.error('Error signing out:', error);
      return false;
    }
  }
} 